import Rating from "@material-ui/lab/Rating";
import ValidationMessages from "../../utils/ValidationMessages";
import { ratingIcons } from "../../utils/utils";
import { useState } from "react";

const InputRating = ({ label, state, inputName, handleRatingChange, validator }) => {
     const [customIcons] = useState(ratingIcons);
     
    const IconContainer = (props) => {
        const { value, ...other } = props;
        const classes = `icons-label ${state == value ? "active" : ""
            }`;
        return (
            <span {...other} className={classes}>
                {customIcons[value].icon}
            </span>
        );
    };

    return (
        <div>
            <h5 className="required">
                {label}
            </h5>

            <div className="form-group row mt-md-5 mt-3 mb-4">
                <div className="col-sm-8 offset-sm-3 text-center">
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            <Rating
                                className="large-rating-icons"
                                name={inputName}
                                defaultValue={0}
                                onChange={(event) => handleRatingChange(event)}
                                getLabelText={(value) => customIcons[value].label}
                                IconContainerComponent={(props) => {
                                    return IconContainer(props);
                                }}
                                size="large"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {validator.current.message(inputName, state, "required", ValidationMessages().rating)}
        </div>

    )

}

export default InputRating;